import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

import { IconService } from './icon.service';
import { EColorPalette, TIconColor } from '@models/colors.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'cmp-icon',
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
      }
    `,
  ],
  templateUrl: './icon.component.html',
  standalone: true,
})
export class IconComponent implements OnInit, OnChanges {
  @Input() size = '45';
  @Input() name = '';
  @Input() color: TIconColor = 'white';
  @Input() hoverColor: TIconColor;
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private iconService: IconService,
  ) {}

  ngOnInit(): void {
    const name = this.name === 'tbsc' ? 'bsc' : this.name;
    
    this.iconService.loadSvg(name).subscribe((svgElement) => {
      this.createSVGIcon(svgElement);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { name, color } = changes;

    if ((name && !name.firstChange) || (color && !color.firstChange)) {
      this.iconService.loadSvg(this.name).subscribe((svgElement) => {
        this.createSVGIcon(svgElement);
      });
    }
  }

  private createSVGIcon(svgElement: SVGElement): void {
    if (svgElement) {
      this.renderer.setAttribute(svgElement, 'width', this.size);
      // Add height so it doesnt break IE layout
      this.renderer.setAttribute(svgElement, 'height', this.size);
      this.renderer.setAttribute(svgElement, 'fill', EColorPalette[this.color] || this.color);
      const element = this.elementRef.nativeElement;

      element.innerHTML = '';
      this.renderer.appendChild(element, svgElement);
    }
  }
}
